module.exports = __webpack_public_path__ + "img/wechat_qr.ab345525.png";